import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { reject } from 'lodash'

import { AppThunk } from '../store'
import {
  getTeamList,
  postTeam,
  patchTeam,
  deleteTeam,
} from '../../apis/team'
import { setErrors } from '../common/errorsSlice'
import {
  SimpleTeam,
  SimpleMember,
  GetTeamListResponse,
  AddTeamRequest,
  UpdateTeamRequest,
  TeamRelation,
} from '../../types/team'

interface TeamListState {
  full_members: SimpleMember[]
  teams: SimpleTeam[]
  team_relations: TeamRelation[]
  isLoading: boolean
}

const initialState: TeamListState = {
  full_members: [],
  teams: [],
  team_relations: [],
  isLoading: true,
}

const teamListSlice = createSlice({
  name: 'teamList',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getTeamSuccess: (state, action: PayloadAction<GetTeamListResponse>) => {
      state.full_members = action.payload.full_members
      state.teams = action.payload.team_list
      state.isLoading = false
      return state
    },
    deleteListTeam: (state, action: PayloadAction<number>) => {
      state.teams = reject(state.teams, { team_id: action.payload })
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
    resetTeam: () => initialState,
  },
})

export const {
  requestStart,
  getTeamSuccess,
  deleteListTeam,
  requestFailure,
  resetTeam,
} = teamListSlice.actions

export const teamListReducer = teamListSlice.reducer

export const fetchTeamList = (
  callback: () => void,
  isLoading = true,
): AppThunk => async (dispatch) => {
  if (isLoading) dispatch(requestStart())
  getTeamList()
    .then((result) => {
      dispatch(getTeamSuccess(result))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const AddTeam = (
  params: AddTeamRequest,
  callback: () => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorCallback: (arg: any) => void,
): AppThunk => async (dispatch) => {
  postTeam(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error.errors))
      errorCallback(error.errors)
    })
}

export const UpdateTeam = (
  teamId: number,
  params: UpdateTeamRequest,
  callback: () => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorCallback: (arg: any) => void,
): AppThunk => async (dispatch) => {
  patchTeam(teamId, params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error.errors))
      errorCallback(error.errors)
    })
}

export const DeleteTeam = (
  teamId: number,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  deleteTeam(teamId)
    .then(() => {
      dispatch(deleteListTeam(teamId))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error.errors))
    })
}
